<template>
  <div class="storico-rottame">
    <div class="row row-custom">
      <div class="titolo-app col-24 no-padding">
        <span class="titolo-bold">
          {{ $t('storicoRottame.storicoRottame').toUpperCase() }}
        </span>
      </div>
      <div class="contenitore col-24 no-padding" :style="{ height: contenitoreHeight + 'px' }">
        <keep-alive>
          <router-view @openSearch="ricercaPanelVisible = true"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StoricoRottame',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true
      }
    },
    i18n: {
      messages: {
        it_IT: {
          storicoRottame: {
            storicoRottame: 'Storico Viaggi'
          }
        },
        fr_FR: {
          storicoRottame: {
            storicoRottame: 'Histoire de Voyage'
          }
        },
        es_ES: {
          storicoRottame: {
            storicoRottame: 'Historia de Viajes'
          }
        },
        de_DE: {
          storicoRottame: {
            storicoRottame: 'Reisegeschichte'
          }
        },
        en_GB: {
          storicoRottame: {
            storicoRottame: 'Travel History'
          }
        }
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .storico-rottame {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebStoricoRottame/StoricoRottame.vue